import { ChatContainer } from "./ChatContainer";
import { SideBrainContainer } from "./SideBrainContainer";
import { ContextContainer } from "./ContextContainer";
import type { KnowledgeView } from "./KnowledgeBar";

interface KnowledgePanelProps {
  activeView: KnowledgeView;
}

export function KnowledgePanel({ activeView }: KnowledgePanelProps) {
  return (
    <div className="h-full w-full bg-background flex flex-col overflow-hidden min-w-0">
      {/* Panel Content */}
      <div className="flex-1 min-h-0 overflow-hidden flex flex-col min-w-0">
        {activeView === "chat" && <ChatContainer />}

        {activeView === "sidebrain" && <SideBrainContainer />}

        {activeView === "context" && <ContextContainer />}

        {activeView === "files" && (
          <div className="p-4 text-muted-foreground">Files coming soon...</div>
        )}

        {activeView === "search" && (
          <div className="p-4 text-muted-foreground">Search coming soon...</div>
        )}
      </div>
    </div>
  );
}
